import React from 'react';

const ConfirmationPopup = ({ title, message, onConfirm, onCancel, show, children,  isApprove}) => {
    if (!show) {
        return null;
    }

    return (
        <div 
        // id="popup-overlay"
            className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
        >
            <div className="bg-white rounded-lg p-8 shadow-2xl w-full max-w-xl mx-auto py-12">
                <h2 className="text-2xl font-bold text-center mb-4 text-2xl">{title}</h2>
                <p className="text-center text-gray-600 mb-6 text-2xl">{message}</p>
                <div className="mb-6">
                    {children}
                </div>
                <div className="flex justify-center space-x-6 py-3">
                    <button 
                        onClick={onCancel} 
                        className="bg-green-500 text-white text-2xl font-bold py-2 px-6 rounded-lg hover:bg-green-600 transition-colors duration-300">
                        No, Keep It
                    </button>
                    <button 
                        onClick={onConfirm} 
                        className="bg-white text-green-500 text-2xl border border-green-500 font-bold py-2 px-6 rounded-lg hover:bg-green-50 transition-colors duration-300">
                        Yes, {isApprove ? 'Approve' : 'Reject'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmationPopup;
